import { app, HostClientType } from "@microsoft/teams-js";
import { UtilityService } from "../services/UtilityService";

export const shareFileIfSupported = async (file: File): Promise<"saved" | "cancelled" | "unsupported"> => {
    if (typeof navigator.canShare !== "function" || !navigator.canShare({ files: [file] })) {
        return "unsupported";
    }

    try {
        await navigator.share({ files: [file], title: file.name });
        return "saved";
    } catch (error: any) {
        if (error?.name === "AbortError") {
            return "cancelled";
        }
        return "unsupported";
    }
};

export const saveBlobOnDevice = async (
    blob: Blob,
    fileName: string,
    contentType?: string
): Promise<"saved" | "cancelled" | "failed"> => {
    const type = contentType || blob.type || "application/octet-stream";
    const file = new File([blob], fileName, { type });

    const shareResult = await shareFileIfSupported(file);
    if (shareResult === "saved" || shareResult === "cancelled") {
        return shareResult;
    }

    try {
        const url = URL.createObjectURL(blob);
        const link = document.createElement("a");
        link.href = url;
        link.setAttribute("download", fileName);
        link.rel = "noopener";
        document.body.appendChild(link);
        link.click();
        document.body.removeChild(link);
        setTimeout(() => URL.revokeObjectURL(url), 2500);
        return "saved";
    } catch {
        return "failed";
    }
};
